let widgetOpen = false;

// eslint-disable-next-line import/prefer-default-export
export function toggleSupport() {
  if (window.duet) {
    if (widgetOpen) {
      window.duet.close();
    } else {
      window.duet.open();
    }
    // Warning: race condition possible.
    widgetOpen = !widgetOpen;
    return true;
  }
  return false;
}

export function setupDecagon() {
  if (window.duet) {
    // Don't show the widget by default. Note: won't trigger if the script is not loaded.
    window.duet.hide();

    window.duet.setEventListener((event) => {
      // eslint-disable-next-line default-case
      switch (event?.eventName) {
        case 'DUET_INITIALIZE':
          widgetOpen = true;
          break;
        case 'DUET_DEINITIALIZE':
          widgetOpen = false;
          break;
      }
    });
  }
}
